/**
 * Formats numbers in British English format (1,000,000.56)
 * @param {number|string} value - The number to format
 * @param {number} decimals - Number of decimal places (default: 2)
 * @returns {string} - Formatted number string
 */
export const formatNumberBritish = (value, decimals = 2) => {
    if (value === null || value === undefined || value === '') return '-';

    const num = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(num)) return '-';

    // Use British English locale for formatting
    return new Intl.NumberFormat('en-GB', {
        minimumFractionDigits: Number.isInteger(num) ? 0 : decimals,
        maximumFractionDigits: decimals,
    }).format(num);
};

/**
 * Formats percentage values in British English format
 * @param {number|string} value - The percentage value
 * @returns {string} - Formatted percentage string
 */
export const formatPercentageBritish = (value) => {
    if (value === null || value === undefined || value === '') return '-';

    const num = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(num)) return '-';

    return `${formatNumberBritish(num, 2)}%`;
};

/**
 * Checks if a field name is a time field that should not be formatted
 * @param {string} fieldName - The field name to check
 * @returns {boolean} - True if it's a time field
 */
export const isTimeField = (fieldName) => {
    if (!fieldName || typeof fieldName !== 'string') return false;

    const lowerFieldName = fieldName.toLowerCase();

    // Check for specific time field patterns
    const timePatterns = [
        'avg time',
        'avg eng time',
        'average time',
        'average engagement time',
        'session time',
        'engagement time',
        'viewing time',
        'total time'
    ];

    return timePatterns.some(pattern => lowerFieldName.includes(pattern)) ||
        (lowerFieldName.includes('time') && (lowerFieldName.includes('avg') || lowerFieldName.includes('average')));
}; 